import Request from "../../lib/request";
import { PROJECT_USER_ID } from "../../constants/storageKeys";
import {
  IMPREST_BUDGET_BY_ACCOUNT_TITLE_API,
  IMPRESTS_BUDGETS_API,
  PROJECT_USERS_API,
  REPORTS_API
} from "../../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const show = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_BUDGETS_API}/${id}`,
    needToken: true
  });
};

export const showByAccountTitles = finalFilter => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${IMPREST_BUDGET_BY_ACCOUNT_TITLE_API}`,
    needToken: true,
    data: finalFilter
  });
};
